import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Fragment } from 'react';
import Box from '../Box';
import Tools from '../Tools';

const AdminTaskField = (props) => {

    const [formData, setFormData] = useState({ positionRef1: null, positionRef2:null});
    const [error, setError] = useState(false);
    const [taskFields, setTaskFields] = useState([]);
    const [fieldTypes, setFieldTypes] = useState([]);
    const [currentNewTaskFieldTypeCode, setCurrentNewTaskFieldTypeCode] = useState('');
    
    const [builtPosition, setBuiltPosition] = useState([]);

    const history = useHistory();

    useEffect(() => {

        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        } else {
        
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            //fieldTypes
            let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/fieldType`);
            fetch(url, {
                method: 'GET',
                contentType: 'application/json',
                headers: { 'Authorization': currentSessionData.token }
            })
            .then(res => {
                if (res.status === 401) { Tools.logout(history); }
                return res.json();
            })
            .then(
                (result) => {
                    setFieldTypes(result.fieldTypes);
                },
                (error) => {
                    setError(error);
                }
            );

        }
    }, []);

    

    const handleInputChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value })
    }

    const getCurrentNewTaskFieldTypeCode = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value })
        let fieldType = Tools.findElementByKey(fieldTypes, 'field_type_id', event.target.value);
        setCurrentNewTaskFieldTypeCode(fieldType.field_type_code);
    }

    const getTaskFields = (taskType) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/taskField`);
        url.search = new URLSearchParams({
            taskType: taskType,
        });

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
            headers: { 'Authorization': currentSessionData.token }
        })
            .then(res => {
                if (res.status === 401) { Tools.logout(history); }
                return res.json();
            })
            .then(
                (result) => {
                    setTaskFields(result.taskFields);
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                }
            )
    }

    const saveTaskField = () => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        let builtPosition=(formData.positionRef1 && formData.positionRef2) ? Number(formData.positionRef2) + Number(formData.positionRef1):0;

        let data = {
            taskTypeId: props.parentTaskType,
            taskFieldName: formData.newTaskFieldName,
            taskFieldType: formData.newTaskFieldType,
            taskFieldLabel: formData.newTaskFieldLabel,
            taskFieldLength: (formData.newTaskFieldLength) ? formData.newTaskFieldLength : 'null',
            taskFieldList: (formData.newTaskFieldList) ? formData.newTaskFieldList : 'null',
            taskFieldPosition: builtPosition
        };

        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/taskField`);
        fetch(url, {
            method: 'POST',
            contentType: 'application/json',
            headers: { 'Authorization': currentSessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(
                (result) => {
                    props.parentMethodToExecuteAfterEdit();
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                }
            )

    }

    return (
        <Fragment>
            <h3>Nuevo campo gestion</h3>
            <p>Ingrese los campos solicitados y haga click en "Añadir campo de gestión".</p>
            <div className="flexRow">
                <div className="flexCol">
                    <Box type="text" name="newTaskFieldName" label="Nombre campo" className="x2" placeholder="Ingrese nombre ..." onChange={handleInputChange}></Box>
                    <Box type="select" name="newTaskFieldType" label="Tipo campo" className="x2" placeholder="Seleccione ..." options={fieldTypes} onChange={getCurrentNewTaskFieldTypeCode} required></Box>
                </div>
            </div>
            <div className="flexRow">
                <div className="flexCol">
                    <Box type="text" name="newTaskFieldLabel" label="Etiqueta" className="x2" placeholder="Ingrese etiqueta ..." onChange={handleInputChange}></Box>

                    {currentNewTaskFieldTypeCode === 'TXT' ? (
                        <Box type="text" name="newTaskFieldLength" label="Largo" placeholder="Ingrese largo ..." onChange={handleInputChange}></Box>
                    ) : null}

                    {currentNewTaskFieldTypeCode === 'LIST' ? (
                        <Box type="select" name="newTaskFieldList" label="Lista asociada" placeholder="Seleccione ..." options={[]} onChange={handleInputChange} required></Box>
                    ) : null}


                    {props.listOfAllTaskFields.length > 0 ? (
                    <Fragment>
                        <Box type="select" name="positionRef1" label="Ubicación" placeholder="Seleccione ..." options={[{ 'a': '-5', 'b': 'Antes de' }, { 'a': '+5', 'b': 'Después de' }]} onChange={handleInputChange} required></Box>
                        <Box type="select" name="positionRef2" label="Campo" placeholder="Seleccione ..." options={props.listOfAllTaskFields} colsSelect={[5, 3]} onChange={handleInputChange} required></Box>
                    </Fragment>
                    ) : null}
                    
                    <button className="collapsed" type="button" onClick={() => saveTaskField()}>Añadir campo de gestión</button>
                </div>
            </div>
        </Fragment>
    );
    
}

export default AdminTaskField;